import { render } from "./CalculationItemImpregnation.vue?vue&type=template&id=5f7a7655"
import script from "./CalculationItemImpregnation.vue?vue&type=script&lang=js"
export * from "./CalculationItemImpregnation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__